export default function getPages(state, props, hide = []) {
    const { pages, customer = {}, locale = {} } = state

    if (!pages) {
        return []
    }

    const { actions = [] } = customer
    const { id, language, country } = locale

    return pages
        .filter((page) => {
            if (hide.includes(page.id)) return false
            if (page.id === 'eip') return false
            if (page.id === 'managegiftcodes' && !actions.includes('MANAGE_GIFT_CODES')) return false
            if (page.id === 'managecards' && !actions.includes('MANAGE_CARDS')) return false
            return true
        })
        .map((page) => {
            const item = { ...page }
            if (item.to) item.to = `/${id}${item.to}`
            if (item.href) item.href = item.href.replace('{language}', language).replace('{country}', country.toLowerCase())
            return item
        })
}
